import React from 'react';
import { styled } from '@glitz/react';
import Modal from 'Shared/Modal';
import { ButtonTheme, SolidButton } from 'Shared/TextButtons';
import CheckoutError from 'Shared/Icons/CheckoutError';
import { translate } from '@polarnopyret/scope';

type PropType = {
  errors: string[];
  showErrors: boolean;
  toggleErrors: () => void;
};

const ErrorContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  textAlign: 'center',
  position: 'relative',
});

const ErrorText = styled.span({
  display: 'block',
});

const ErrorTextWrapper = styled.div({ 
  width: '100%',
});

const ConfirmButton = styled(SolidButton, {
  marginTop: '24px',
  width: '100%',
});

const SomethingWrongIcon = styled(CheckoutError, {
  height: '20px',
  width: '20px',
  margin: { xy: 'auto' },
  fontSize: '20px',
});

const IconWrapper = styled.div({
  marginBottom: '16px',
});

const formatErrors = (errors: string[]) => {
  return errors.map((error, index) => <ErrorText key={index}>{error}</ErrorText>);
};

export default (props: PropType) => {
  return (
    <Modal
      header={translate('/site/shared/genericerror')}
      toggleModal={props.toggleErrors}
      isOpen={props.showErrors}
      canOpen
      maxHeight={'400px'}
      maxWidth={'400px'}
      allowOverflow
    >
      <ErrorContainer>
        <IconWrapper>
          <SomethingWrongIcon />
        </IconWrapper> 
        <ErrorTextWrapper>{formatErrors(props.errors)}</ErrorTextWrapper>
        <ConfirmButton onClick={props.toggleErrors} theme={ButtonTheme.BlackToWhite} display="block">{translate('/site/shared/ok')}</ConfirmButton>
      </ErrorContainer> 
    </Modal>
  );
};
